module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_2.d33d2ef4.png";